// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChevronPanel__panel___ZCheA {
	width: 100%;
	border-radius: 4px;
	margin: 3px 0px;
}

.ChevronPanel__label___qK8U4 {
	font-family: "IM Fell French Canon SC";
	text-align: center;
}

.ChevronPanel__panel_opened___xa49R {
	padding: 5px;
}

.ChevronPanel__icon___hUiZy {
	margin-right: 8px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `ChevronPanel__panel___ZCheA`,
	"label": `ChevronPanel__label___qK8U4`,
	"panel_opened": `ChevronPanel__panel_opened___xa49R`,
	"icon": `ChevronPanel__icon___hUiZy`
};
module.exports = ___CSS_LOADER_EXPORT___;
